import { domUtils } from '@domoscio/domoscio-sdk-js'

/**
 * Decode HTML entities in a string like 'Cr&#xe9;er une section' to 'Créer une section'
 * @param str - The string to decode
 * @returns The decoded string
 */
export const decodeHtmlEntities = (str: string) => {
  return domUtils.decodeHtmlEntities(str)
}
